import { useNavigate } from "react-router-dom";

export default function RoadmapIntro() {
  const navigate = useNavigate();

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 py-8 font-inter">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-center text-black leading-tight">
          Begin Your Roadmap Now
        </h1>

        <p className="mt-3 text-center text-[#313439] max-w-2xl mx-auto font-medium text-sm sm:text-base leading-relaxed">
          Your first step toward a personalized path to success. In just 5–7
          minutes, discover your strengths and get matched with courses,
          careers, and opportunities made for you.
        </p>

        {/* Info Cards */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          
          {/* Why it matters */}
          <div className="bg-[#FAF7FF] border border-[#EEE5FF] rounded-2xl p-5 sm:p-6">
            <h3 className="font-semibold text-base sm:text-lg text-gray-900 mb-4">
              Why it matters :
            </h3>

            <ul className="space-y-3 text-sm sm:text-base text-gray-700">
              {[
                "Your results help us build a step-by-step roadmap tailored to your skills and goals.",
                "Discover careers and courses that align with your strengths and passions.",
                "Gain insight and guidance to make smarter academic and career choices.",
              ].map((text, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <img
                    src="/star.png"
                    alt="star"
                    className="w-4 h-4 mt-1 shrink-0"
                  />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Tips */}
          <div className="bg-[#FAF7FF] border border-[#EEE5FF] rounded-2xl p-5 sm:p-6">
            <h3 className="font-semibold text-base sm:text-lg text-gray-900 mb-4">
              Tips for best results :
            </h3>

            <ul className="space-y-3 text-sm sm:text-base text-gray-700">
              {[
                "Be honest in your answers to get accurate recommendations.",
                "Take your time to reflect on your strengths and interests.",
                "Use this as a chance to explore new paths you may not have considered.",
              ].map((text, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <img
                    src="/star.png"
                    alt="star"
                    className="w-4 h-4 mt-1 shrink-0"
                  />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-10 border bg-[linear-gradient(91.57deg,#FAFCFF_0.24%,#FFEFD4_103.52%)] rounded-2xl p-5 sm:p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          
          {/* Left Content */}
          <div className="text-center md:text-left">
            <h3 className="text-base sm:text-lg md:text-xl font-bold text-black">
              Unlock Your Timeline
            </h3>

            <p className="mt-2 text-sm sm:text-base font-medium text-black">
              A few minutes now, guidance for years ahead. <br className="hidden sm:block" />
              Ready to discover your path?
            </p>

            <button
              onClick={() => navigate("/personality-quiz")}
              className="mt-4 w-full sm:w-auto bg-[#6B2D8D] hover:bg-[#5A2576] text-white text-sm sm:text-base font-medium px-6 py-2.5 rounded-lg transition"
            >
              Take the Personality Quiz
            </button>
          </div>

          {/* Illustration */}
          <div className="w-full max-w-[180px] sm:max-w-[220px] md:max-w-[250px]">
            <img
              src="/Pa.png"
              alt="Roadmap illustration"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

      </div>
    </div>
  );
}